import React, { useState, useEffect } from "react";
import { Button, Modal, ModalBody } from "@windmill/react-ui";
import getEmployeeId from "utils/commonAdmin";
import * as countryCodes from "country-codes-list"; // Import the country-codes-list package

const id_employee = getEmployeeId();

// Prepare the country code list using country-codes-list
const countryCodeList = countryCodes.customList(
  "countryCallingCode",
  "{countryNameEn} ({countryCallingCode})"
);

// Transform the list into an array of objects for the dropdown
const countryCodeOptions = Object.entries(countryCodeList).map(([code, name]) => ({
  code: code.startsWith("+") ? code : `+${code}`, // Ensure the code starts with "+"
  name: name.split(" (")[0], // Extract the country name (e.g., "India")
  label: `${name.split(" (")[0]} (${code.startsWith("+") ? code : `+${code}`})`, // Format: "India (+91)"
}));

// Find India as the default country (using country code +91)
const defaultCountry = countryCodeOptions.find((country) => country.code === "+91") || countryCodeOptions[0];

const DriverSmsModal = ({
  id,
  isOpen,
  onClose,
  title = "Send Customer details to Driver",
  contactnumber,
  handleSubmit,
  isSubmitting,
  customClass = "",
}) => {
  const [mobileno, setMobileno] = useState("");
  const [error, setError] = useState("");
  const [selectedSmsOption, setSelectedSmsOption] = useState(1);
  const [selectedCountryCode, setSelectedCountryCode] = useState(defaultCountry.code); // Default to India (+91)
  const [showCountryCode, setShowCountryCode] = useState(false);
// console.log(id)
  useEffect(() => {
    if (!isOpen) {
      setMobileno("");
      setError("");
      setSelectedCountryCode(defaultCountry.code); // Reset to India when modal closes
    }
    setMobileno(contactnumber || "");
  }, [isOpen, contactnumber]);

  useEffect(() => {
    // Show country code dropdown only for WhatsApp
    setShowCountryCode(selectedSmsOption === 2);
  }, [selectedSmsOption]);

const handleSubmitSms = () => {
  let numberToValidate = mobileno.trim();
  let countryCodeRaw = "";

  // If sending via WhatsApp (selectedSmsOption === 2)
  if (selectedSmsOption === 2) {
    countryCodeRaw = selectedCountryCode || "";
    const codeNoPlus = countryCodeRaw.replace(/^\+/, "");

    // Remove leading '+' if present in selectedCountryCode
    countryCodeRaw = codeNoPlus;

    // Strip the code from the entered mobile number if it was pasted
    if (numberToValidate.startsWith(codeNoPlus)) {
      numberToValidate = numberToValidate.slice(codeNoPlus.length);
    }
  }

  // Basic validations
  if (!numberToValidate) {
    setError("Mobile Number is required!");
    return;
  }

  if (!/^[0-9]+$/.test(numberToValidate)) {
    setError("Mobile Number must contain only digits!");
    return;
  }

  if (numberToValidate.length !== 10) {
    setError("Mobile Number must be exactly 10 digits!");
    return;
  }

  setError("");

  // Build payload with separated country code and mobile number
  const payload = {
    mobileno: numberToValidate,        // e.g. "9876543210"
    type: selectedSmsOption,           // e.g. 2
    id_employee: id,
    ...(selectedSmsOption === 2 && {  // only include code for WhatsApp
      contact_no_country_code: countryCodeRaw, // e.g. "91"
    }),
  };

  handleSubmit(payload);
};


  const handleSmsChange = (e) => {
    setSelectedSmsOption(Number(e.target.value));
  };

  const handleCountryCodeChange = (e) => {
    setSelectedCountryCode(e.target.value);
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) {
      setMobileno(value);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={`relative bg-white pb-0 p-4 w-1/3 rounded-lg ${customClass}`}
      aria-labelledby="modal-title"
    >
      <span id="modal-title" className="flex text-2xl text-black-500 ml-3">
        {title}
      </span>
      <ModalBody className="!mb-0 text-center custom-modal pt-3 pb-4">
        <div className="radio-input-wrapper flex items-center space-x-4">
          <label className="label pe-md-3 py-1 py-sm-2">
            <input
              type="radio"
              id="1"
              className="radio-type me-1"
              value={1}
              checked={Number(selectedSmsOption) === 1}
              onChange={handleSmsChange}
            />
            <span className="ml-2">SMS</span>
          </label>

          <label className="label pe-md-3 py-1 py-sm-2">
            <input
              type="radio"
              id="2"
              className="radio-type me-1"
              value={2}
              required
              checked={Number(selectedSmsOption) === 2}
              onChange={handleSmsChange}
            />
            <span className="ml-2">WhatsApp</span>
          </label>
        </div>

        {showCountryCode && (
          <div className="mt-4">
            <label htmlFor="country-code" className="block text-sm font-medium text-gray-700 mb-1 text-left">
              Country Code
            </label>
            <select
              id="country-code"
              value={selectedCountryCode}
              onChange={handleCountryCodeChange}
              className="w-full border border-gray-300 rounded p-2"
            >
              {countryCodeOptions.map((country) => (
                <option key={country.code} value={country.code}>
                  {country.label}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="mt-4">
          <label htmlFor="phone-number" className="block text-sm font-medium text-gray-700 mb-1 text-left">
            Mobile Number
          </label>
          <div className="flex">
            {showCountryCode && (
              <div className="flex items-center justify-center px-3 border border-r-0 border-gray-300 rounded-l bg-gray-100">
                {selectedCountryCode}
              </div>
            )}
            <input
              id="phone-number"
              className={`w-full border border-gray-300 rounded${showCountryCode ? '-l-none rounded-r' : ''} p-2`}
              placeholder={showCountryCode ? "1234567890" : "Enter Mobile Number"}
              value={mobileno}
              type="number"
              autoComplete="off"
              maxLength={10}
              onChange={handlePhoneChange}
              style={{ height: "100%" }}
            />
          </div>
          {error && <p className="text-red-500 text-sm mt-2 text-left">{error}</p>}
        </div>

        <div className="flex items-center justify-around gap-4 mt-8">
          <Button
            onClick={handleSubmitSms}
            disabled={isSubmitting}
            className="bg-green-500 hover:bg-green-600 text-white w-full sm:w-auto"
          >
            Send
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DriverSmsModal;